import { render, staticRenderFns } from "./NftBlock.vue?vue&type=template&id=5fad68ef&scoped=true&"
import script from "./NftBlock.vue?vue&type=script&lang=js&"
export * from "./NftBlock.vue?vue&type=script&lang=js&"
import style0 from "./NftBlock.vue?vue&type=style&index=0&id=5fad68ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad68ef",
  null
  
)

export default component.exports